import React from 'react';
import './TabNav.css';
interface TabNotification {
  tabIndex: number;
  count: number;
}
interface TabNavProps {
  tabs: string[];
  activeTab: number;
  onTabChange: (index: number) => void;
  notifications?: TabNotification[];
  inactiveTabs?: number[];
  inactiveTabsTooltips?: Record<string, string>; // Nouveau: messages pour les onglets inactifs
  disabledTabs?: number[]; // Nouvelle prop
  rightAlignedTabs?: string[]; // Onglets à aligner à droite
}

const TabNav: React.FC<TabNavProps> = ({
  tabs,
  activeTab,
  onTabChange,
  notifications = [],
  inactiveTabs = [],
  inactiveTabsTooltips = {}, // Par défaut, aucun message personnalisé
  disabledTabs = [],
  rightAlignedTabs = [],
}) => {
  const leftTabs = tabs.filter(tab => !rightAlignedTabs.includes(tab));
  const rightTabs = tabs.filter(tab => rightAlignedTabs.includes(tab));

  const renderTab = (tab: string, index: number) => {
    const originalIndex = tabs.indexOf(tab);
    const notification = notifications.find(n => n.tabIndex === originalIndex);
    const isInactive = inactiveTabs.includes(originalIndex);
    const isDisabled = disabledTabs.includes(originalIndex);
    const tooltipMessage = isInactive
      ? (inactiveTabsTooltips[tab] || "Fonctionnalité en cours de développement")
      : isDisabled
        ? "Non disponible dans ce statut"
        : "";

    return (
      <button
        key={originalIndex}
        className={`tab-button ${activeTab === originalIndex ? 'active' : ''} ${isInactive ? 'inactive' : ''} ${isDisabled ? 'disabled' : ''}`}
        onClick={() => !isInactive && !isDisabled && onTabChange(originalIndex)}
        disabled={isInactive || isDisabled}
        title={tooltipMessage}
        data-tooltip={tooltipMessage}
      >
        {tab}
        {notification && notification.count > 0 && (
          <span className="notification-badge">
            {notification.count}
          </span>
        )}
      </button>
    );
  };

  return (
    <div className="tab-nav">
      <div className="tab-nav-left">
        {leftTabs.map((tab, index) => renderTab(tab, index))}
      </div>
      {rightTabs.length > 0 && (
        <div className="tab-nav-right">
          {rightTabs.map((tab, index) => renderTab(tab, index))}
        </div>
      )}
    </div>
  );
};

export default TabNav;